import ITicket from "@/interfaces/ITicket";

import CardHeader from "@/components/Includes/CardHeader/CardHeader.vue";
import capitalizeFirstLetter from "@/libs/capitalizeFirstLetter";
import {Component, Prop, Vue} from 'vue-property-decorator';



@Component({
    name: 'TicketForm',
    components: {
        CardHeader
    }
})
export default class TicketForm extends Vue {
    @Prop(Object) private formData!: ITicket;

    private transformValue(value: any): string {
        return value ? String(value) : '–';
    }

    private transformLabel(field: string): string {
        return capitalizeFirstLetter(field);
    }

    private hideFields(field: string): boolean {
        return field === 'id' || field === 'updatedAt';
    }
}
